import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description WalletBag icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { WalletBag } from '@sravni/design-system-icons'
 *
 * <WalletBag />
 * ```
 */
var WalletBag = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "WalletBag", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.509 5H4.491c-.684 0-1.128.748-.82 1.381l.462.952a.917.917 0 0 0 .82.524h10.094a.915.915 0 0 0 .82-.524l.462-.952C16.637 5.748 16.192 5 15.51 5v0ZM6.924 4.009C7.822 4.81 9.234 5 9.917 5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.918 5s.41-2.224-.6-3.128M6.924 4.009c-.66-.59-.66-1.547 0-2.138.66-.59 1.733-.59 2.393 0M13.076 4.009c-.898.802-2.31.992-2.993.992", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.082 5s-.41-2.224.6-3.128M13.076 4.009c.66-.59.66-1.547 0-2.138-.66-.59-1.733-.59-2.393 0M4.362 8.572l-2.408 3.773a3.311 3.311 0 0 0-.525 1.788c0 .83.315 1.633.888 2.262l.889.974a3.756 3.756 0 0 0 2.775 1.203h8.038a3.756 3.756 0 0 0 2.775-1.203l.889-.974c.573-.63.889-1.432.889-2.262 0-.631-.182-1.25-.527-1.79l-2.407-3.771", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { WalletBag };
//# sourceMappingURL=WalletBag.js.map
